import {Moment} from 'moment';

import {
  IDepotStatistics,
  IFarmInputProgram,
  IFdApplicationType,
} from 'constants/interfaces';

export enum EAnalyticsDateRange {
  NONE,
  CUSTOM,
  TODAY,
  THIS_WEEK,
  THIS_MONTH,
  THIS_YEAR,
  LAST_7_DAYS,
  LAST_30_DAYS,
  ALL_TIME,
}

export type AnalyticsBreakdownRow = {
  label: string;
  count?: number;
  value?: number;
  percent?: number;
};

export type AnalyticsTopProductRow = {
  name: string;
  quantity: number;
  value: number;
};

export type ReportSectionId =
  | 'summary'
  | 'orderQuotes'
  | 'funding'
  | 'programs'
  | 'productActivity'
  | 'supplierEngagement';

export type ReportSectionOption = {
  id: ReportSectionId;
  label: string;
  description: string;
};

export type AnalyticsReportInput = {
  companyName: string;
  companyLogo?: string;
  generatedAt: Moment;
  khulaLogo: string;
  rangeLabel: string;
  selectedSections: ReportSectionId[];
  stats: IDepotStatistics;
  applications: IFdApplicationType[];
  programs: IFarmInputProgram[];
  totalFundingAsk: number;
  averageApplicationCompletion: number;
  totalProgramHectares: number;
  salesConversion: number;
  paidOrderRate: number;
  fundingStatusRows: AnalyticsBreakdownRow[];
  fundingCategoryRows: AnalyticsBreakdownRow[];
  programStatusRows: AnalyticsBreakdownRow[];
  programTypeRows: AnalyticsBreakdownRow[];
  topQuoteProducts: AnalyticsTopProductRow[];
  topOrderProducts: AnalyticsTopProductRow[];
  supplierEngagementRows: Array<{name: string; numberOfViews: number}>;
};

export const DEFAULT_REPORT_SECTIONS: ReportSectionId[] = [
  'summary',
  'orderQuotes',
  'funding',
  'programs',
  'productActivity',
];
